var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaIconType24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,63.6C14.6,63.6,0.4,49.4,0.4,32S14.6,0.4,32,0.4S63.6,14.5,63.6,32S49.4,63.6,32,63.6z M32,5.2 C17.2,5.2,5.2,17.2,5.2,32s12,26.8,26.8,26.8s26.8-12,26.8-26.8S46.8,5.2,32,5.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.2,45.8v-6.7c0-2.7-2.2-4.8-4.8-4.8h-6.7c-0.4,0-0.8-0.4-0.8-0.8V21c1.7-0.8,2.9-2.4,2.9-4.4 c0-2.8-2.2-4.8-4.8-4.8c-2.8,0-4.8,2.2-4.8,4.8c0,1.7,0.9,3.2,2.2,4.1l-5.5,4.8V34h3.9v-6.7l2.5-2.1v8.4c0,2.6,2.1,4.6,4.6,4.6 h6.7c0.6,0,1,0.5,1,1v10.6h6.6v-3.9L47.2,45.8L47.2,45.8z M32.8,18.6c-1.2,0-1.9-0.9-1.9-1.9c0-1.2,0.9-1.9,1.9-1.9 c1,0,1.8,0.8,1.9,1.9C34.7,17.8,34,18.6,32.8,18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.3,39.6c-0.1,2.9-1.6,5.6-4,7.2c-2,1.4-4.4,1.9-6.8,1.5c-2.4-0.5-4.4-1.8-5.8-3.9c-1.4-2-1.9-4.4-1.5-6.8 c0.5-2.4,1.8-4.4,3.9-5.8l0.6-0.4l-2.3-3.3l-0.6,0.4c-3.6,2.5-5.7,6.4-5.7,10.8c0,7.1,5.8,12.9,12.9,12.9c7,0,12.7-5.6,13-12.6 C40.1,39.6,36.3,39.6,36.3,39.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaIconType24);
export default __webpack_public_path__ + "static/media/aioa-icon-type-24.931634d468b712690021ab3165a9dad0.svg";
export { ForwardRef as ReactComponent };